module.exports = __webpack_public_path__ + "static/media/samsung-pay.3a569b2d.svg";